import React, {Component} from 'react';
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import countryList from './CountryList';
import {withTranslation} from "react-i18next";

const styles = theme => ({
    formControl: {
        minWidth: 120
    }
});

class CountrySelect extends Component {
    handleChange = event => {
        if (this.props.onCountrySelected) {
            this.props.onCountrySelected(event.target.value);
        }
    };

    render() {
        const {classes, t, excludeCountries} = this.props;

        let countries = countryList;
        if (excludeCountries) {
            countries = countryList.filter(e => !excludeCountries.includes(e.code));
        }

        const selectItems = countries.map(item => {
            return <MenuItem key={item.code} value={item.code}>{item.name}</MenuItem>;
        });

        return (
            <FormControl margin="normal" fullWidth className={classes.formControl}>
                <InputLabel shrink>
                    {t('registrationForm.player.country')}
                </InputLabel>
                <Select
                    value={this.props.country}
                    onChange={(e) => this.handleChange(e)}
                    name="country">
                    {selectItems}
                </Select>
            </FormControl>
        );
    }
}

export default withStyles(styles)(withTranslation('messages')(CountrySelect));